var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FlatpageLegalBase", [
    _c("h1", [_vm._v("Brilliant Cookie Policy")]),
    _vm._v(" "),
    _c("p", [_c("em", [_vm._v("Effective: May 21, 2018")])]),
    _vm._v(" "),
    _c(
      "p",
      [
        _vm._v(
          "\n    Please remember that your use of the Services is at all times subject to the\n    "
        ),
        _c("router-link", { attrs: { to: { name: "flatpage_termsofuse" } } }, [
          _vm._v("Terms of Use")
        ]),
        _vm._v("\n    and\n    "),
        _c(
          "router-link",
          { attrs: { to: { name: "flatpage_privacypolicy" } } },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v(
          ", which\n    incorporates this Cookie Policy. Any terms we use in this Cookie Policy without defining them\n    have the definitions given to them in the\n    "
        ),
        _c("router-link", { attrs: { to: { name: "flatpage_termsofuse" } } }, [
          _vm._v("Terms of Use")
        ]),
        _vm._v("\n    and\n    "),
        _c(
          "router-link",
          { attrs: { to: { name: "flatpage_privacypolicy" } } },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v(".\n  ")
      ],
      1
    ),
    _vm._v(" "),
    _c("h2", [_vm._v("Cookie Policy")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    The Services use cookies and similar technologies such as pixel tags, web beacons, clear GIFs,\n    JavaScript, and local storage. Cookies are small files – usually consisting of letters\n    and numbers – placed on your computer, tablet, phone, or similar device, when you use\n    that device to visit a Site. We will refer to cookies and similar technologies simply as\n    "Cookies" for the remainder of this Cookie Policy. We use cookies to enable our servers to\n    recognize your web browser and tell us how and when you visit and otherwise use the Services\n    through the internet, to analyze trends, and to learn about our user base.\n  '
      )
    ]),
    _vm._v(" "),
    _c(
      "p",
      [
        _vm._v(
          "\n    We may combine non-personally identifiable information collected through cookies with other\n    Personal Information that we have about you, for example, to tell us who you are or whether\n    you have an account. We may also supplement the information we collect from you with\n    information received from third parties in order to enhance our Services, or to offer you\n    information that we believe may be of interest to you. Where we use Cookies to collect\n    information that is personally identifiable, or that can become personally identifiable if we\n    combine it with other information, the Brilliant\n    "
        ),
        _c(
          "router-link",
          { attrs: { to: { name: "flatpage_privacypolicy" } } },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v("\n    will apply in addition to this Cookie Policy.\n  ")
      ],
      1
    ),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    You can control and/or delete cookies as you wish – for details, see\n    "
      ),
      _c(
        "a",
        { attrs: { href: "https://www.aboutcookies.org/", target: "_blank" } },
        [_vm._v("aboutcookies.org")]
      ),
      _vm._v(
        ". Most browsers\n    have an option for turning off the cookie feature, which will prevent your browser from\n    accepting new cookies, as well as (depending on the sophistication of your browser software)\n    allowing you to decide on acceptance of each new cookie in a variety of ways. You can delete\n    all cookies that are already on your computer and you can set most browsers to prevent them\n    from being placed. If you do this, however, you may have to manually adjust some preferences\n    every time you visit a site and some services and functionalities may not work. We strongly\n    recommend that you leave cookies active, because they enable you to take advantage of the most\n    attractive features of the Services.\n  "
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v("\n    Further information on cookies can be found\n    "),
      _vm.isMobile(_vm.$mq)
        ? _c("span", [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://wikis.ec.europa.eu/display/WEBGUIDE/04.+Cookies+and+similar+technologies",
                  target: "_blank"
                }
              },
              [_vm._v("here")]
            ),
            _vm._v(".\n    ")
          ])
        : _c("span", [
            _vm._v("\n      at\n      "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm",
                  target: "_blank"
                }
              },
              [
                _vm._v(
                  "http://ec.europa.eu/ipg/basics/legal/cookies/index_en.htm"
                )
              ]
            ),
            _vm._v(".\n    ")
          ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "anchor", attrs: { id: "types-of-cookies" } }),
    _vm._v(" "),
    _c("h2", [
      _vm._v("What Types of Cookies Do We Use and For Which Purposes?")
    ]),
    _vm._v(" "),
    _c("p", [_vm._v("We use the following types of Cookies:")]),
    _vm._v(" "),
    _c("h3", [_vm._v("Essential Cookies")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    These are cookies that are required to provide you with features or services that you have\n    requested. For example, Cookies that enable you to log into secure areas of our site or use a\n    shopping cart. Disabling these Cookies will encumber the Services’ performance and may make\n    certain features and services unavailable.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Analytical Cookies")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    These Cookies allow us to understand how visitors use our site. This includes information\n    about the number of visitors to the site, what pages visitors view on our site and how long\n    visitors are viewing pages on the site. Analytical Cookies also help us measure the\n    performance of our advertising campaigns in order to help us improve our advertising campaigns\n    and to optimize our Services’ content for those who engage with our advertising.\n  "
      )
    ]),
    _vm._v(" "),
    _c("header", [
      _c("h3", [_vm._v("Third Party Cookies")]),
      _vm._v(" "),
      _c(
        "span",
        { class: { locked: _vm.thirdPartyCookiesCheckboxLocked } },
        [
          _c(
            "CustomChoiceElement",
            {
              ref: "thirdPartyCookiesCheckbox",
              attrs: {
                type: "checkbox",
                disabled:
                  _vm.privacyProperties.under_17 ||
                  _vm.thirdPartyCookiesCheckboxLocked
              },
              on: { change: _vm.toggleThirdPartyCookies },
              model: {
                value: _vm.thirdPartyCookiesEnabled,
                callback: function($$v) {
                  _vm.thirdPartyCookiesEnabled = $$v
                },
                expression: "thirdPartyCookiesEnabled"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "label",
                  class: { disabled: !_vm.thirdPartyCookiesCheckboxEnabled }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.thirdPartyCookiesCheckboxEnabled
                          ? "enabled"
                          : "disabled"
                      ) +
                      "\n        "
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.privacyProperties.under_17
        ? _c("div", { staticClass: "disabled-cookies-notice" }, [
            _vm._v(
              "\n      Third party cookie tracking is automatically disabled for all users under the age of 17.\n    "
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    These are Cookies placed by a third party on your device and may provide information to those\n    third parties about browsing habits (including your visits to our Services, the pages you have\n    visited and the links and advertisements you have clicked) that may help identify if certain\n    services that such third parties provide are being used, identify your interests, retarget you\n    and serve advertisements that are relevant to you. We do not have control or access to such\n    Cookies. If you look at one page on our Services, an advertisement may be delivered to you on\n    our Services or on other sites, for products referenced on that page or for similar products\n    and services. We do not engage in retargeted advertising for children users of our Services.\n  "
      )
    ]),
    _vm._v(" "),
    _c("h3", [_vm._v("Session Cookies and Persistent Cookies")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    The types of Cookies described above may be "session Cookies" which are temporary Cookies that\n    are only stored on your device while you are visiting our site or "persistent Cookies" which\n    are Cookies that are stored on your device for a period of time after you leave our site. The\n    length of time a persistent Cookie stays on your device varies from Cookie to Cookie. We use\n    persistent Cookies to store your preferences so that they are available for the next visit,\n    and to keep a more accurate account of how often you visit our Services, how often you return,\n    how your use of the Services may vary over time, and measure the effectiveness of advertising\n    efforts. Through these Cookies, we may collect information about your online activity after\n    you leave our Services. Just like any other usage information we collect, this information\n    allows us to improve the Services and customize your online experience. Your browser may offer\n    you a "Do Not Track" option, which allows you to signal to operators of websites and web\n    applications and services (including behavioral advertising services) that you do not wish\n    such operators to track certain of your online activities over time and across different\n    websites. Our Services do not support Do Not Track requests at this time, which means that we\n    collect information about your online activity both while you are using the Services and after\n    you leave the Services.\n  '
      )
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Cookie Settings")]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    You can decide whether or not to accept Cookies. One way you can do this is through your\n    internet browser’s settings. To find our more information about Cookies, including information\n    about how to manage and delete Cookies, please visit\n    "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://ico.org.uk/your-data-matters/online/cookies/",
            target: "_blank"
          }
        },
        [
          _vm._v(
            "\n      https://ico.org.uk/your-data-matters/online/cookies/\n    "
          )
        ]
      ),
      _vm._v("\n    or\n    "),
      _c(
        "a",
        {
          attrs: { href: "https://www.allaboutcookies.org/", target: "_blank" }
        },
        [_vm._v("\n      https://www.allaboutcookies.org/ ")]
      ),
      _vm._v(".\n  ")
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        '\n    To explore what Cookie setting are available to you, look in the "preferences" or "options"\n    section of your browser\'s menu.\n  '
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        "\n    If you have any queries regarding this Cookie Policy please contact us at\n    "
      ),
      _c("a", { attrs: { href: "mailto:privacy+cookies@brilliant.org" } }, [
        _vm._v("privacy+cookies@brilliant.org")
      ]),
      _vm._v(".\n  ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }